import { createSlice } from "@reduxjs/toolkit";
import VwKullaniciRolyetkiDTO from "src/models/RolYetki/VwKullaniciRolyetkiDTO";

const arayuzSession: IArayuzAuthState = sessionStorage.getItem('arayuzAuth')
    ? JSON.parse(sessionStorage.getItem('arayuzAuth'))
    : {
        data: [],
        isLoading: false,
        error: ""
    };
export interface IArayuzAuthState {
    data: Array<VwKullaniciRolyetkiDTO>;
}

const ArayuzYetkiSlice = createSlice<IArayuzAuthState, {}>({
    name: 'ArayuzAuthState',
    initialState: arayuzSession,
    reducers: {
    },
    extraReducers: (builder) => {
        // builder.addCase(getArayuzAuth.pending, (state, { payload }) => {
        //     state.isLoading = true
        // })
        // builder.addCase(getArayuzAuth.fulfilled, (state, action) => {
        //     state = {
        //         data: action.payload.data.map(m => {
        //             switch (m.yetkikodu) {
        //                 case 'KULLANICIDETAY':
        //                     m.name = 'pages|menu|kullaniciDetay';
        //                     m.link = '/management/generals/kullanici-tanim/detay';
        //                     break;
        //                 case 'KULLANICIEKLE':
        //                     m.name = 'pages|menu|kullaniciDetay';
        //                     m.link = '/management/generals/kullanici-tanim/ekle';
        //                     break;
        //                 case 'PERSONELDETAY':
        //                     m.name = 'pages|menu|personelDetay';
        //                     m.link = '/management/generals/personel-tanim/detay';
        //                     break;
        //                 case 'PERSONELEKLE':
        //                     m.name = 'pages|menu|personelDetay';
        //                     m.link = '/management/generals/personel-tanim/ekle';
        //                     break;
        //                 case "KIMLIKTANIM":
        //                     m.name = "pages|menu|kullaniciTanim";
        //                     m.link = "/management/generals/kimlik-detay";
        //                     break;
        //                 case "REFERANSDOKTORDETAY":
        //                     m.name = 'pages|menu|referansDoktorDetay';
        //                     m.link = '/management/generals/referans-doktor/detay';
        //                     break;
        //                 case "REFERANSDOKTOREKLE":
        //                     m.name = 'pages|menu|referansDoktorEkle';
        //                     m.link = '/management/generals/referans-doktor/ekle';
        //                     break;
        //                 default:
        //                     m.link = '';
        //                     break;
        //             }
        //             return {
        //                 code: m.yetkikodu,
        //                 level: m.seviye,
        //                 link: m.link,
        //                 name: m.name,
        //                 parentKey: m.bagliId,
        //                 key: m.id,
        //                 value: m.yetkiadi
        //             }
        //         }),
        //         isLoading: false,
        //         error: action.payload.errorMessage
        //     }
        //     sessionStorage.setItem('arayuzAuth', JSON.stringify(state));
        //     return state
        // })
    }
})
export default ArayuzYetkiSlice;